var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Trigger, TransparentButton } from "../..";
import { CardHeaderContainer, CardHeaderTitle, CardHeaderActionsWrapper } from './';
export var ExpandableCardHeaderWithActions = function (_a) {
    var title = _a.title, actions = _a.actions, onClick = _a.onClick, _b = _a.isExpandable, isExpandable = _b === void 0 ? false : _b, _c = _a.isExpanded, isExpanded = _c === void 0 ? false : _c, _d = _a.trigger, TriggerComponent = _d === void 0 ? Trigger : _d, _e = _a.triggerColor, triggerColor = _e === void 0 ? 'primary' : _e, props = __rest(_a, ["title", "actions", "onClick", "isExpandable", "isExpanded", "trigger", "triggerColor"]);
    var handleClick = function (e) {
        if (typeof onClick === 'function') {
            onClick(e);
        }
    };
    return (React.createElement(CardHeaderContainer, { isExpanded: isExpanded, isExpandable: isExpandable, lss: props.lss },
        React.createElement(TransparentButton, { type: "button", onClick: handleClick, lss: {
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                py: 'sm'
            }, "aria-expanded": isExpanded },
            isExpandable && TriggerComponent && (React.createElement(TriggerComponent, { isExpanded: isExpanded, isStatic: true, triggerColor: triggerColor })),
            React.createElement(CardHeaderTitle, { title: title, titleLss: props.titleLss })),
        React.createElement(CardHeaderActionsWrapper, { actions: actions })));
};
//# sourceMappingURL=ExpandableCardHeaderWithActions.js.map